$(function(){
  onloadVariantImage();
  onloadVariantDropdown();
  getEngraveText();
  getEngraveColor();
});
$(window).bind('scroll load', function() {
    var scroll = $(window).scrollTop();    
    if (scroll >= 20) {
        $("#shopify-section-header").addClass('scrolled');
    } else {
        $("#shopify-section-header").removeClass('scrolled');
    }
});

$(window).bind('load', function() {
  if($('.add-to-cart-panel')) {
    var fullHeight = $('.add-to-cart-panel').height() + 150;
//     $('.product-page--top-panel--container').css('height', fullHeight);
  }
});
var positionMax;
var stickyHeight;
var scrollDifference;
var popupImgWidth;

$(window).bind('load resize', function() {
  if($('.template--product')) {
      positionMax = $('.product-page--top-panel').height();
      stickyHeight = $('.product-slider-wrappper').height();
      scrollDifference = positionMax - stickyHeight;
      if ($(document).scrollTop() >= scrollDifference) {
		$('.product-page--top-panel').addClass('fakesticky');
      } else {
		$('.product-page--top-panel').removeClass('fakesticky');
      }
    	$('.popup-text-overlay > .overlay-text-out').css('transform', 'scale('+$(window).width() / 2 / parseInt($('.popup-text-overlay').attr('data-ptext-bg'))+')')
    }
});

$(window).bind('load resize scroll', () => {
  	if($('.template--product')) {
      if ($(document).scrollTop() >= scrollDifference) {
		$('.product-page--top-panel').addClass('fakesticky');
      } else {
		$('.product-page--top-panel').removeClass('fakesticky');
      }
	}
});
function toggleVideo() {
   $('.video-popup').toggleClass('visible');
}
$(window).on('click', '.bc-sf-filter-option-block', function(){
  // console.log('test');
});
$(document).on('click', '.category-backbtn', function(e){
    e.preventDefault();
  // console.log('hi');
    window.history.back();
});
$(document).on('click', '.product-backbtn', function(e){
    e.preventDefault();
  // console.log('hi');
    window.history.back();
});
$(document).on('click','.filter-dropdown',function(){
  if ($('.filter-dropdown').hasClass('active')) {
    $('.filter-dropdown').removeClass('active');
  	$(".filter-panel").not(this).slideUp();
  } else {
  	$(".filter-panel").not(this).slideDown();
    $('.filter-dropdown').addClass('active');
  }
});
$(document).ready(function(){
    $('.product-page-you-may-like .like-wrapper').flickity({
      freeScroll: false,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      contain: true
    });
});
cartJSAddQuery = (vid, qty, prop) => {
  return new Promise((resolve, reject) => {
  CartJS.addItem(vid, qty, prop,
  {
    "success": function(data, textStatus, jqXHR) {
      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        beforeSend: function() {
          // console.log('before');
        },
        success: function(cart) {
          resolve();
          // console.log('success',location.pathname);
        }
      });
    },
    "error": function(jqXHR, textStatus, errorThrown) {
      reject();
      alert('Something is wrong with the order, please try again.')
      location.reload();
    }
  })
  });
}
url = new URL(window.location.href);
typeBAddToCart = (evt) => {
  // if (!url.searchParams.has('o2odev')) {
  //  var $this = $(evt);
  // var $perObject = {};
  // var $mainObject = {};
  // var $personaliseVid = parseInt($this.attr('data-persVId'));
  // var $mainProductId = parseInt($('.product-page--variant-select').val());
  // var $mainVariant = $('.product-page--variant-select').find(':selected').attr('data-sku');
  // var $personaliseTitle = $this.attr('data-personaliseTitle');
  // var $mainTitle = $this.attr('data-mainTitle');

  // var $fontFamily = $('.font-family-select').val();
  // var $engraveColor = $('.input-radio-foil:checked').val();
  // var $engraveText = $('.engraveTextInput').val();
  // if ($('#jotun_sn').length > 0) {
  //   var $jotun_sn = $('#jotun_sn').val();
  //   var $jotun_receipt = $('input[name*="properties[Jotun Receipt 1]"]').val();
    
  // }
  // if ($('#jotun_sid').length > 0) {
  //   var $jotun_sid = $('#jotun_sid').val();
  // }
  // var $replaceDot = $engraveText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  // // Show announcement header bar
  // $('#shopify-section-announcement').css('display','block');
  // $('#shopify-section-header').css('display','block');

  // if ($fontFamily == null) {
  //   $('#font-family-error').show();
  // } else {
  //   $('#font-family-error').hide();
  //   $perObject['Add Name'] = $engraveText;
  //   $perObject['Foil'] = $engraveColor.replace('-', ' ');
  //   $perObject['Font'] = $fontFamily.replace('-', ' ').replace('-', ' ');
  //   $perObject['Product'] = $mainTitle + ' - ' + $mainVariant;
  //   $perObject['BindID'] = $mainProductId+'-'+$personaliseVid+'-'+$replaceDot+'-'+$engraveColor+'-'+$fontFamily;
  //   $perObject['Personalisation'] = true;

  //   $mainObject['Add Name'] = $engraveText;
  //   $mainObject['Foil'] = $engraveColor.replace('-', ' ');
  //   $mainObject['Font'] = $fontFamily.replace('-', ' ').replace('-', ' ');
  //   $mainObject['Product'] = $personaliseTitle;
  //   $mainObject['BindID'] = $mainProductId+'-'+$personaliseVid+'-'+$replaceDot+'-'+$engraveColor+'-'+$fontFamily;
  //   if ($('#jotun_sn').length > 0) {
  //     $mainObject['Jotun Gift Card Serial Number'] = $jotun_sn;
  //     $mainObject['Jotun Receipt 1'] = $jotun_receipt;
  //   }
  //   if ($('#jotun_sid').length > 0) {
  //     $mainObject['Jotun Staff ID'] = $jotun_sid
  //   }
  //   // console.log('Personalise id $mainObject'+JSON.stringify($mainObject));
  //   // console.log('main product id $perObject'+JSON.stringify($perObject));
  //   cartJSAddQuery($personaliseVid,1,$perObject);
  //   cartJSAddQuery($mainProductId,1,$mainObject);

  //   $(document).on('cart.requestComplete', function(event, cart) {
  //     renderCartDrawer();
  //     $('.js-close').click();
  //     $('.closePopup').click();
  //   });
  //   setTimeout(function(){
  //     $('.js-cart-drawer').click(function(e){e.preventDefault();}).click();
  //   },3000);
  // }
  // }  else {
  const $this = $(evt);
  const $personaliseVid = parseInt($this.attr('data-persVId'));
  const $mainProductId = parseInt($('.product-page--variant-select').val());
  const $mainVariant = $('.product-page--variant-select').find(':selected').attr('data-sku');
  const $personaliseTitle = $this.attr('data-personaliseTitle');
  const $mainTitle = $this.attr('data-mainTitle');

  const $fontFamily = $('.font-family-select').val();
  const $engraveColor = $('.input-radio-foil:checked').val();
  const $engraveText = $('.engraveTextInput').val();
  const $jotun_sn = $('#jotun_sn').length > 0 ? $('#jotun_sn').val() : null;
  const $jotun_receipt = $('#jotun_sn').length > 0 ? $('input[name*="properties[Jotun Receipt 1]"]').val() : null;
  const $jotun_sid = $('#jotun_sid').length > 0 ? $('#jotun_sid').val() : null;

  const $replaceDot = $engraveText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  // Show announcement header bar
  $('#shopify-section-announcement').css('display', 'block');
  $('#shopify-section-header').css('display', 'block');

  if (!$fontFamily) {
    $('#font-family-error').show();
    return;
  }

  const perObject = {
    'Add Name': $engraveText,
    'Foil': $engraveColor.replace('-', ' '),
    'Font': $fontFamily.replace('-', ' ').replace('-', ' '),
    'Product': $mainTitle + ' - ' + $mainVariant,
    'BindID': `${$mainProductId}-${$personaliseVid}-${$replaceDot}-${$engraveColor}-${$fontFamily}`,
    'Personalisation': true,
  };

  const mainObject = {
    'Add Name': $engraveText,
    'Foil': $engraveColor.replace('-', ' '),
    'Font': $fontFamily.replace('-', ' ').replace('-', ' '),
    'Product': $personaliseTitle,
    'BindID': `${$mainProductId}-${$personaliseVid}-${$replaceDot}-${$engraveColor}-${$fontFamily}`,
  };

  if ($jotun_sn) {
    mainObject['Jotun Gift Card Serial Number'] = $jotun_sn;
    mainObject['Jotun Receipt 1'] = $jotun_receipt;
  }

  if ($jotun_sid) {
    mainObject['Jotun Staff ID'] = $jotun_sid;
  }

  cartJSAddQuery($personaliseVid, 1, perObject).then(() => {
    cartJSAddQuery($mainProductId, 1, mainObject);
  });

  $(document).on('cart.requestComplete', function(event, cart) {
    renderCartDrawer();
    $('.js-close').click();
    $('.closePopup').click();
  });

  setTimeout(function(){
    $('.js-cart-drawer').click(function(e){e.preventDefault();}).click();
  }, 3000);
  // }
}
plusQty = (evt) =>{
  var $this = $(evt);
  var $actionVal = 'plus-';
  plusMinusBindClick($this,$actionVal);
}

minusQty = (evt) =>{
  var $this = $(evt);
  var $actionVal = 'minus-';
  plusMinusBindClick($this,$actionVal);
}

removeLineItem = (evt) =>{
  var $this = $(evt);
  console.log( $this);
  $this.parent().siblings('.cart--item--remove').children().click();
}

plusMinusBindClick = (e,actionVal) =>{
  var $bindId = e.attr('data-bindId');
  var $varId = e.closest('.cart--item').attr('data-variant-id');
  // console.log(e);
  if ($varId == 36978910167104) {
    // console.log('test1');
  var $varPersId = e.closest('.cart--item').parent().children('[data-variant-id="36978753208384"]');
  }
  
  var $plusMinusBlocker = $('.plusMinusBlocker');
  // disabled +/- button
  $plusMinusBlocker.show();
  setTimeout(function(){
    $('.'+actionVal+$bindId).click();
    if ($varId == 36978910167104) {
      if (actionVal == 'plus-') {
      $('[data-variant-id="36978753208384"] .plus').click();
      } else {
        // console.log($varPersId);
      $('[data-variant-id="36978753208384"] .minus').click();
      }
    }
    // enabled +/- button
    setTimeout(function(){
      $plusMinusBlocker.hide();
    },2500);
  },800);
}
variantImage = (evt) =>{
  // console.log('1');
  var $this = $(evt);
  var $color = $this.attr('data-color');
  // console.log($color);
  var $pdpBottomImage = $('.varImage');
  var $popupImage = $('.popup-variant-img');

  $pdpBottomImage.hide();
  $popupImage.hide();

  $pdpBottomImage.each(function(){
    var $_this = $(this);
    var $_color = $_this.attr('data-varColor');
    if ($_color == $color || $_color == $color+'-text' || $_color == 'main_content' || $_color == 'main_content-text') {
      $_this.show();
    }
  });
  $popupImage.each(function(){
    var $_this = $(this);
    var $_color = $_this.attr('alt');
    if ($_color == $color || $_color == $color+'-text' || $_color == 'main_content' || $_color == 'main_content-text') {
      $_this.show();
    }
  });
  
  setTimeout(function(){
  injectProductImg($color);
  }, 500);
}

onloadVariantImage = () =>{
  var $getColor = $('.varColorRadio:checked').val();
  var $pdpBottomImage = $('.varImage');
  var $popupImage = $('.popup-variant-img');
  $pdpBottomImage.hide();
  $popupImage.hide();

  $pdpBottomImage.each(function(){
    var $_this = $(this);
    var $_color = $_this.attr('data-varColor');
    if ($_color == $getColor || $_color == $getColor+'-text' || $_color == 'main_content' || $_color == 'main_content-text') {
      $_this.attr('wat','asd')
      $_this.show();
    }
  });
  $popupImage.each(function(){
    var $_this = $(this);
    var $_color = $_this.attr('alt');
    if ($_color == $getColor || $_color == $getColor+'-text' || $_color == 'main_content' || $_color == 'main_content-text') {
      $_this.attr('wat','asd')
      $_this.show();
    }
  });
  injectProductImg($getColor);
}

getEngraveText = () =>{
  var $engraveText = localStorage.getItem("engraveText");
  var $overlayText = $('.overlay-text');
  var $engraveInput = $('.engraveTextInput');
  var $engraveCharNum = $engraveInput.siblings('.count_p');
  var $limit = parseInt($engraveCharNum.attr('data-limit'));
  var $maxLength = parseInt($('.engraveTextInput').attr('maxlength'));
  if ($engraveText) {
    var $trimString = $engraveText.substring(0, $maxLength);
  
    $overlayText.text($trimString);
    $engraveInput.val($trimString);
    $engraveCharNum.text($trimString.length+'/'+$limit);
  }

}

onInputTypeB = (evt) =>{
  if (evt !== null){
  var $this = $(evt);
  } else {
  var $this = $('.engraveTextInput');
  }

  // remove emoji and transform text to uppercase
  // Disable special character
  var regex = new RegExp("['.&a-zA-Z0-9\U+0263E\U+02764]+$");
  var temp = $this.val().replace(/[^'.&a-zA-Z0-9[\U+0263E][\U+02764][\U+2605]☾♥★\s]/g, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
  if ($this.hasClass('capitalize')) {
    
  } else if ($this.hasClass('uppercase')) {
             
  	$this.val(temp.toUpperCase());
  
  } else {
  }
  if ($this.hasClass('alphaonly')) {
  var $val = $this.val().replace(/[^'.&a-zA-Z\s]/g, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
  } else {
  var $val = $this.val().replace(/[^'.&a-zA-Z0-9[\U+0263E][\U+02764][\U+2605]☾♥★\s]/g, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
  }
  
  
  var $textCount = $val.length;
  var $overlayText = $('.overlay-text');
  var $overlayTextOut = $('.overlay-text-out');
  var $engraveInput = $('.engraveTextInput');
  var $engraveCharNum = $engraveInput.siblings('.count_p');
  var $limit = parseInt($engraveCharNum.attr('data-limit'));

  if ($val.length >= $limit) {
    $val = $val.substr(0, $limit);
  }

  $engraveInput.val( $val );

  /* TODO */
  if ($('#shopify-section-product-type-new-uv').length > 0) {
    $('.overlay-text').parent().removeClass('capitalize uppercase');
    let $currentFontFamily = $('.font-family-select option:selected').val();
    if ($currentFontFamily == 'Catchland' ) {
    	$('.overlay-text').parent().addClass('capitalize');
		let tempCatchland = $this.val(); 
		tempCatchland = tempCatchland.charAt(0).toUpperCase() + tempCatchland.slice(1).toLowerCase();
        // console.log(tempCatchland.charAt(0));
        $('.engraveTextInput').val(tempCatchland);
    } else if ($currentFontFamily == 'Olive-Days' || $currentFontFamily == 'Magic-Soul' ) {
        // console.log($this.val().toUpperCase());
    	$('.engraveTextInput').val($this.val().toUpperCase());
        // console.log($('.engraveTextInput').val());
    	$('.overlay-text').parent().addClass('uppercase');
    } 
  }
  
  if ($textCount <= $limit) {
    $this.siblings('.count_p').text($textCount+'/'+$limit);
    $overlayText.text($val);
    $overlayTextOut.text($val);
    localStorage.setItem("engraveText", $val);
  }
  // set localStorage


}
onInputTypeGreetCard = (evt) =>{
  var $this = $(evt);
  var temp = $this.val().replace(/[^"'.,:;@?!(){}<>[]+-*&#$%^&a-zA-Z0-9\s]/g, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');
  $this.val(temp);
}
// isEmoji = (str) =>{
//   // Credit: https://github.com/jquery/jquery-mobile/issues/8616#issuecomment-371375460
//   var ranges = [
//     '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
//     '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
//     '\ud83d[\ude80-\udeff]' // U+1F680 to U+1F6FF
//   ];
//   if (str.match(ranges.join('|'))) {
//     return true;
//   } else {
//     return false;
//   }
// }

// removeEmoji = (str) =>{
//   var ranges = [
//     '\ud83c[\udf00-\udfff]', // U+1F300 to U+1F3FF
//     '\ud83d[\udc00-\ude4f]', // U+1F400 to U+1F64F
//     '\ud83d[\ude80-\udeff]' // U+1F680 to U+1F6FF
//   ];
//   var replacedStr = str.replace(new RegExp(ranges.join('|'), 'g'), '');
//
//   return replacedStr;
// }

getEngraveColor = () =>{
  var $engraveColor = localStorage.getItem("engraveColor");

  $('#'+$engraveColor).click();
}

changeFontColor = (evt) =>{
  var $this = $(evt);
  var $colorVal = $this.attr('data-color');
  var $texture = $this.attr('data-texture');
  var $showFoil = $this.attr('data-showfoil');

  $('.show-foil-text').text($showFoil);
  $('.overlay-text').css('color',$colorVal);
  // $('.overlay-text').css('background','-webkit-linear-gradient(transparent, transparent),url("'+$texture+'") no-repeat center center');
  $('.overlay-text-out').css('color',$colorVal);
  // $('.overlay-text-out').css('background','-webkit-linear-gradient(transparent, transparent),url("'+$texture+'") no-repeat center center');
  $('.foil-radio').children('.foil-swatch').removeClass('is-selected');
  $this.addClass('is-selected');

  if ($showFoil == 'Blind (no colour)' || $showFoil == 'Gold' || $showFoil == 'Silver' || $showFoil == 'Rose gold') {
    $('.overlay-text').css('background','-webkit-linear-gradient(transparent, transparent),url("'+$texture+'") no-repeat center center');
    $('.overlay-text').addClass('tempClass');
    $('.overlay-text-out').css('background','-webkit-linear-gradient(transparent, transparent),url("'+$texture+'") no-repeat center center');
    $('.overlay-text-out').addClass('tempClass');
  } else {
    $('.overlay-text').css('background','none');
    $('.overlay-text').removeClass('tempClass');
    $('.overlay-text-out').css('background','none');
    $('.overlay-text-out').removeClass('tempClass');
  }
  // set localStorage
  localStorage.setItem("engraveColor", $this.attr('id'));
}

changeFontFamily = (evt) =>{
  var $this = $(evt);
  var $val = $this.val();
  var $characterLimit = parseInt($this.find(':selected').attr('data-charLimit'));
  // swap class to display the correct font family
  $('.overlay-text').removeClass('Avenir Times-New-Roman Bebas-Neue Lora Big-Shoulders Alex-Brush Richard-Hamilton Block Cursive Vinyl-Block Vinyl-Block-Big Olive-Days Catchland Magic-Soul');
  if ($val == 'Cursive') {
  	$('.overlay-text').parent().addClass('Cursive');
  } else {
  	$('.overlay-text').parent().removeClass('Cursive');
  }
  $('.overlay-text').addClass($val);
  $('.overlay-text-out').removeClass('Avenir Times-New-Roman Bebas-Neue Lora Big-Shoulders Alex-Brush Richard-Hamilton Block Cursive Vinyl-Block Vinyl-Block-Big Olive-Days Catchland Magic-Soul');
  $('.overlay-text-out').addClass($val);

  // change text overlay font size
  if ($val == 'Times-New-Roman') {
    $('.overlay-text').css('font-size', '24px');
    $('.overlay-text-out').css('font-size', '24px');
  } else if ($val == 'Avenir') {
    $('.overlay-text').css('font-size', '18px');
    $('.overlay-text-out').css('font-size', '18px');
  } else if ($val == 'Bebas-Neue') {
    $('.overlay-text').css('font-size', '18px');
    $('.overlay-text-out').css('font-size', '18px');
  } else if ($val == 'Richard-Hamilton') {
    $('.overlay-text').css('font-size', '18px');
    $('.overlay-text-out').css('font-size', '18px');
  } else if ($val == 'Lora') {
    $('.overlay-text').css('font-size', '75px');
    $('.overlay-text-out').css('font-size', '75px');
  } else if ($val == 'Big-Shoulders') {
    $('.overlay-text').css('font-size', '38px');
    $('.overlay-text-out').css('font-size', '38px');
  }else if ($val == 'Alex-Brush') {
    $('.overlay-text-c').css('font-size', '38px');
    $('.overlay-text').css('font-size', '38px');
    $('.overlay-text-out').css('font-size', '38px');
  }

  // change character limit for different font family
  var $inputField = $('.engraveTextInput');

  if ($('#shopify-section-product-type-new-uv').length > 0) {
    $('.overlay-text').parent().removeClass('capitalize uppercase');
    if ($val == 'Catchland' ) {
    	$('.overlay-text').parent().addClass('capitalize');
		let tempCatchland = $inputField.val(); 
		tempCatchland = tempCatchland.charAt(0).toUpperCase() + tempCatchland.slice(1).toLowerCase();
        // console.log(tempCatchland.charAt(0));
        $inputField.val(tempCatchland);
    } else if ($val == 'Olive-Days' || $val == 'Magic-Soul' ) {
    	$inputField.val($inputField.val().toUpperCase());
    	$('.overlay-text').parent().addClass('uppercase');
    } 
  }
  var $trimText = $inputField.val().substring(0, $characterLimit);
  $inputField.val($trimText);

  var $inputFieldLength = $inputField.val().length;
  onInputTypeB($('.engraveTextInput'));
  $('.overlay-text').text($trimText);
  $('.overlay-text-out').text($trimText);
  $inputField.attr('maxlength',$characterLimit);
  $('.count_p').attr('data-limit', $characterLimit).text($inputFieldLength+'/'+$characterLimit);
  localStorage.setItem("engraveText", $trimText);
}

toolTipHover = (evt) =>{

  var target = false, tooltip = false, title = false;

  target  = $(evt);
  tip     = target.attr( 'title' );
  tooltip = $('<div id="tooltip"></div>');

  if( !tip || tip == '' )
    return false;

  target.removeAttr( 'title' );
  tooltip.css( 'opacity', 0 ).html( tip ).appendTo( 'body' );

  var init_tooltip = function()
  {
    if( $( window ).width() < tooltip.outerWidth() * 1.5 )
      tooltip.css( 'max-width', $( window ).width() / 2 );
    else
      tooltip.css( 'max-width', 340 );

    var pos_left = target.offset().left + ( target.outerWidth() / 2 ) - ( tooltip.outerWidth() / 2 ), pos_top  = target.offset().top - tooltip.outerHeight() - 20;

    if( pos_left < 0 ){
      pos_left = target.offset().left + target.outerWidth() / 2 - 20;
      tooltip.addClass( 'left' );
    }
    else
      tooltip.removeClass( 'left' );

    if( pos_left + tooltip.outerWidth() > $( window ).width() ){
      pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20;
      tooltip.addClass( 'right' );
    }
    else
      tooltip.removeClass( 'right' );

    if( pos_top < 0 ){
      var pos_top  = target.offset().top + target.outerHeight();
      tooltip.addClass( 'top' );
    }
    else
      tooltip.removeClass( 'top' );

    tooltip.css( { left: pos_left, top: pos_top } ).animate( { top: '+=10', opacity: 1 }, 50 );
  };

  init_tooltip();
  $( window ).resize( init_tooltip );

  var remove_tooltip = function(){
    tooltip.animate( { top: '-=10', opacity: 0 }, 50, function(){
      $( this ).remove();
    });

    target.attr( 'title', tip );
  };

  target.bind( 'mouseleave', remove_tooltip );
  tooltip.bind( 'click', remove_tooltip );
}

variantDropdown = (evt, addOn) =>{
  var $this = $(evt);
  var $current = $this.children('.addOnOption').attr('aria-current') == 'true';
  var $pdpBottomImage = $('.varImage');

  $pdpBottomImage.hide();

  $pdpBottomImage.each(function(){
    var $_this = $(this);
    var $_color = $_this.attr('data-varColor');

    if ($_color == addOn || $_color.includes(addOn+'-text') || $_color == 'main_content' || $_color == 'main_content-text') {
      $_this.show();
    }
  });
}
newVariantDropdown = (evt, addOn) =>{
  var $mediaId = $(evt)[0];
  var $pdpBottomImage = $('.product-mobile-img-cells');

  $pdpBottomImage.hide();

  $pdpBottomImage.each(function(){
    var $_this = $(this);
    var $_media = $_this.attr('data-id');

    if ($_media == $mediaId) {
      $_this.show();
      // console.log('??');
    }
  });
  
  setTimeout(function(){
  injectProductImg2(addOn);
  }, 500);
}
onloadVariantDropdown = () =>{
  // console.log('4');
  var $hasAddOn = $('#isAddOn').val() == 'true';
  if ($hasAddOn) {
    var $this = $('.addOnOption');
    var $pdpBottomImage = $('.varImage');
    var $addOnOptions = '';
    $this.each(function(){
      var $current = $(this).attr('aria-current') == 'true';
      if ($current) {
        $addOnOptions = $(this).attr('data-value');
      }
    });

    $pdpBottomImage.hide();

    $pdpBottomImage.each(function(){
      var $_this = $(this);
      var $_color = $_this.attr('data-varColor');

      if ($_color == $addOnOptions || $_color.includes($addOnOptions+'-text') || $_color == 'main_content' || $_color == 'main_content-text') {
        $_this.show();
      }
    });
    injectProductImg($addOnOptions);
  }
}

injectProductImg = ($getColor) =>{
  var $mobileContainer = $('.mobile-product-slider');
  var $imgs = $('.product-imgs');
  var $mainImage = $('.product-page--featured-media img');
  var $contents = $('.image-wrapper[data-varcolor="main_content"] .product-page--media')
  var $imageCounts = 0;

  // destroy flickity
  $mobileContainer.flickity().flickity('destroy');
  // remove all children
  $mobileContainer.children().remove();

  if ($imgs.length == 1) {
    var $imgHtml = '';
    var $this = $(this);
    $imgHtml += '<div class="product-mobile-img-cells no-border full-width">';

    // append text overlay if exist
//     if ($textContainer.length > 0) {
//       $imgHtml += $textContainer[0].outerHTML;
//     }

    $imgHtml += $mainImage[0].outerHTML;
    $imgHtml += '</div>';
    // append html into container
    // console.log($mainImage);
    $mobileContainer.append($imgHtml);  
  } else {
    var i = 0;
  $imgs.each(function(){
    var $imgHtml = '';
    var $this = $(this);
    var $alt = $this.attr('alt');
    var $textContainer = $this.parents('.product-page--media').find('.popup-text-overlay');
    var $mediaId = $this.parents('.product-page--media').attr('data-id');
    $this.removeClass('lazyautosizes');
//     console.log($getColor);

  	if ($('.radios--root[data-is-swatches="true"] .varColorRadio').length > 0) {
//       https://christyng.com/products/eleanor-buckle-bag?variant=39343519760448 cause alt is Checker Tan
      // console.log($alt);
      if ($getColor == $alt || $alt == $getColor+'-text' || $alt == 'main_content' || $alt == 'main_content-text') {
        i++;
        $imgHtml += '<div class="product-mobile-img-cells no-border full-width pleasewait" data-id="'+$mediaId+'">';

        // append text overlay if exist
        if ($textContainer.length > 0) {
          $imgHtml += $textContainer[0].outerHTML;
        }
        $imgHtml += $this[0].outerHTML;
        $imgHtml += '</div>';
        // append html into container
        $mobileContainer.append($imgHtml);
          $imageCounts = i;
      } else {
      }
    } else {
        i++;
        $imgHtml += '<div class="product-mobile-img-cells no-border full-width pleasewait" data-id="'+$mediaId+'">';

        // append text overlay if exist
        if ($textContainer.length > 0) {
          $imgHtml += $textContainer[0].outerHTML;
        }
        $imgHtml += $this[0].outerHTML;
        $imgHtml += '</div>';
        // append html into container
        $mobileContainer.append($imgHtml);
          $imageCounts = i;
    }
    
    
  })
  };
//   $contents.each(function(){
//     var $imgHtml = '';
//     var $this = $(this);
//     var $alt = $this.attr('alt');
//     $this.removeClass('lazyautosizes');
//     console.log($this);
//     i++;
//     $imgHtml += '<div class="product-mobile-img-cells no-border full-width pleasewait">';
//     $imgHtml += $this[0].outerHTML;
//     $imgHtml += '</div>';
//     // append html into container
//     $mobileContainer.append($imgHtml);
//     $imageCounts = i;
//   })
  $mobileContainer.on( 'ready.flickity', function() {
    $(".mobile-product-slider .product-mobile-img-cells").each(function() {
      $(this).removeClass('pleasewait');
    });
  });
  
  if ($imgs.length > 1) {
  // init flickity slider
  setTimeout(function(){
    var $carousel = $('.mobile-product-slider').flickity({
      freeScroll: false,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true
    }).flickity('resize').flickity('reposition');
    $(window).resize();
  },1000);
    
    $mobileContainer.on( 'change.flickity', function( event, index ) {
      $('.slideCurrent').text( 1 + index );
    });
     $('.slideTotal').text( ' of ' + $imageCounts );
    
  }
}
injectProductImg2 = ($getColor) =>{
  var $mobileContainer = $('.mobile-product-slider');
  var $imgs = $('.content .product-imgs');
  var $mainImage = $('.product-page--featured-media img');
  var $contents = $('.image-wrapper[data-varcolor="main_content"] .product-page--media')
  var $imageCounts = 0;

  // destroy flickity
  $mobileContainer.flickity().flickity('destroy');
  // remove all children
  $mobileContainer.children().remove();
  
  if ($imgs.length == 1) {
    var $imgHtml = '';
    var $this = $(this);

    $imgHtml += '<div class="product-mobile-img-cells no-border full-width">';

    // append text overlay if exist
    if ($textContainer.length > 0) {
      $imgHtml += $textContainer[0].outerHTML;
    }

    $imgHtml += $this[0].outerHTML;
    $imgHtml += '</div>';
    // append html into container
    $mobileContainer.append($imgHtml);  
    // console.log('hi');
    // console.log($imgHtml);
  } else {
    var i = 0;
  $imgs.each(function(){
    var $imgHtml = '';
    var $this = $(this);
    var $alt = $this.attr('alt');
    var $textContainer = $this.parents('.product-page--media').find('.popup-text-overlay');
    var $mediaId = $this.parents('.product-page--media').attr('data-id');
    $this.removeClass('lazyautosizes');
       if ($getColor == $alt || $alt == $getColor+'-text' || $alt == 'main_content' || $alt == 'main_content-text') {
    // console.log($alt);
        i++;
        $imgHtml += '<div class="product-mobile-img-cells no-border full-width pleasewait" data-id="'+$mediaId+'">';

        // append text overlay if exist
        if ($textContainer.length > 0) {
          $imgHtml += $textContainer[0].outerHTML;
        }
        $imgHtml += $this[0].outerHTML;
        $imgHtml += '</div>';
        // append html into container
        $mobileContainer.append($imgHtml);
          $imageCounts = i;
      } else {
      }
    
  })
  };
  $mobileContainer.on( 'ready.flickity', function() {
    $(".mobile-product-slider .product-mobile-img-cells").each(function() {
      $(this).removeClass('pleasewait');
    });
  });
  
  if ($imgs.length > 1) {
  // init flickity slider
  setTimeout(function(){
    var $carousel = $('.mobile-product-slider').flickity({
      freeScroll: false,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true
    }).flickity('resize').flickity('reposition');
    $(window).resize();
  },1000);
    $('.slideCurrent').text(1);
    $mobileContainer.on( 'change.flickity', function( event, index ) {
      $('.slideCurrent').text( 1 + index );
    });
     $('.slideTotal').text( ' of ' + $imageCounts );
    
  }
}